<form nz-form *ngIf="mainformGroup && fieldNew && controlExists" [formGroup]="mainformGroup" [nzLayout]="'vertical'">
    <nz-form-item *ngIf="!field.hide && !hide" [ngStyle]="field.noFormItemMarginBottom?{'margin-bottom':'0'}:{}">
        <nz-form-label *ngIf="!field.noLabel" [nzFor]="fieldNew" [nzRequired]="field.required">{{field.label|translateTA}}</nz-form-label>
        <nz-form-control  [nzValidatingTip]="field.tooltip" nzHasFeedback>
            <nz-select nzShowSearch nzAllowClear nzServerSearch  [formControlName]="fieldNew" [nzPlaceHolder]="field.placeholder|translateTA"  [nzSize]="field.size == null? 'default': field.size" (nzOnSearch)="onSearch($event)" [nzDisabled]="field.isDisabled">
                <!--nz-option [nzLabel]="field.showKey?option['LABEL']+' - '+option['VALUE'] : option['LABEL']" [nzValue]="option['VALUE']" *ngFor="let option of dynamicList|async"></nz-option-->
                @if (!loading) {
                    @for (o of optionList; track o.key) {
                    <nz-option [nzValue]="o.key" [nzLabel]="field.showKey? (o.key + ' - '+ o.value): o.value"></nz-option>
                    }
                } @else {
                    <nz-option nzDisabled nzCustomContent>
                    <nz-icon nzType="loading" class="loading-icon" />
                        {{'loading.data'|translateTA}}
                    </nz-option>
                }
            </nz-select>
        </nz-form-control>
    </nz-form-item>
</form>
